import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

const ProfilePageSubmissionContext = React.createContext(undefined);

export function ProfilePageSubmissionContextProvider({ children }) {
  // Use a ref instead of useState to avoid unnecessary re-renders and some weirdness due to the fact that giving a function to a setter means the function is immediately invoked
  const submitFuncRef = useRef(undefined);
  const profilePageSubmit = useCallback((...args) => {
    if (!submitFuncRef.current) {
      return undefined;
    }
    return submitFuncRef.current(...args);
  }, []);
  const setProfilePageSubmit = useCallback((newFn) => {
    submitFuncRef.current = newFn;
  }, []);

  return (
    <ProfilePageSubmissionContext.Provider value={{ profilePageSubmit, setProfilePageSubmit }}>
      {children}
    </ProfilePageSubmissionContext.Provider>
  );
}

export function useProfilePageSubmissionContext() {
  const context = React.useContext(ProfilePageSubmissionContext);

  if (context === undefined) {
    throw new Error('useProfilePageSubmissionContext must be used within a ProfilePageSubmissionContextProvider');
  }

  return context;
}

ProfilePageSubmissionContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};


export const withProfilePageSubmissionContextProvider = Wrapped => props => {
  return (
    <ProfilePageSubmissionContextProvider>
      <Wrapped {...props} />
    </ProfilePageSubmissionContextProvider>
  );
};
